// src/store/useStore.js

import { create } from "zustand";
import { getAuth } from "firebase/auth";

// Load user profile from localStorage if available
const loadUserProfile = () => {
  const storedProfile = localStorage.getItem("userProfile");
  return storedProfile ? JSON.parse(storedProfile) : null;
};

const useStore = create((set) => ({
  // User Profile State
  userProfile: loadUserProfile(),
  setUserProfile: (userProfile) => {
    if (userProfile) {
      // Ensure the userProfile contains the currentUser.uid
      if (!userProfile.uid) {
        const auth = getAuth();
        const currentUser = auth.currentUser;
        if (currentUser && currentUser.uid) {
          userProfile.uid = currentUser.uid;
        }
      }
      localStorage.setItem("userProfile", JSON.stringify(userProfile));
      set({ userProfile });
    } else {
      console.warn("Attempting to set undefined userProfile");
    }
  },

  clearUserProfile: () => {
    // Clear localStorage items related to the user
    localStorage.removeItem("userProfile");
    localStorage.removeItem("authResponseData");
    // localStorage.removeItem("__paypal_storage__");
    localStorage.removeItem("kbeanToken");
    localStorage.removeItem("artworkData");
    set({ userProfile: null });
  },
}));

export default useStore;
